export default __webpack_public_path__ + "static/media/barnes-noble.269ad69a.png";